import { parseAmount } from '../services/cost-math';
import { getStage3ProgrammeDays, stage3ReadinessLabel } from './stage3-work-method';

export interface StageNavContext {
    icon: string;
    tone: 'info' | 'success' | 'warn';
    text: string;
}

export interface NavScopeTotals {
    items: number;
    totalLabel: string;
    totalDisplay: string;
    title: string;
}

export function fmtNavMoney(value: unknown): string {
    const n = Number(value);
    if (!Number.isFinite(n) || n <= 0) return '$0';
    return n.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 });
}

export function fmtNavPercent(value: unknown): string {
    const n = Number(value);
    if (!Number.isFinite(n)) return '0%';
    const rounded = Math.round(n * 10) / 10;
    return `${Number.isInteger(rounded) ? rounded.toFixed(0) : rounded.toFixed(1)}%`;
}

export function resolveSavedQuoteTotalForNav(quoteData: any): number {
    return parseAmount(quoteData?.totalIncGst)
        || parseAmount(quoteData?.totals?.totalIncGst)
        || parseAmount(quoteData?.totals?.total)
        || parseAmount(quoteData?.summary?.totalIncGst)
        || parseAmount(quoteData?.summary?.total);
}

export function computeStageNavContext(options: {
    stage: number;
    projectWMS: any;
    projectWMSGenerating: boolean;
    stage3MethodAssessment: any;
}): StageNavContext | null {
    const { stage, projectWMS, projectWMSGenerating, stage3MethodAssessment } = options;
    if (stage === 3) {
        const activities = Array.isArray(projectWMS?.structured?.activities) ? projectWMS.structured.activities : [];
        const core = activities.filter((a: any) => !a?.is_recommendation).length;
        const days = getStage3ProgrammeDays(projectWMS);
        const readiness = stage3MethodAssessment && Array.isArray(stage3MethodAssessment.reasons) ? stage3ReadinessLabel(stage3MethodAssessment) : 'ready';
        return {
            icon: projectWMSGenerating ? 'Loader2' : 'ClipboardCheck',
            tone: projectWMSGenerating ? 'info' : stage3MethodAssessment?.ready ? 'success' : 'warn',
            text: projectWMSGenerating
                ? 'Work Method generating - activity pricing and programme are being built'
                : `Work Method ${readiness === 'ready' ? '' : `(${readiness}) `}- ${core} activit${core === 1 ? 'y' : 'ies'} - ${days || 0} programme day${days === 1 ? '' : 's'}`,
        };
    }
    return null;
}

export function buildNavScopeTotals(options: {
    stage: number;
    quoteEditorOpen: boolean;
    navMessage: any;
    quoteDataForNav: any;
    scope: any[];
    scopeGstInclusive: boolean;
    quoteTotalForNav: number;
    scopeTotalForNav: number;
}): NavScopeTotals | null {
    const {
        stage,
        quoteEditorOpen,
        navMessage,
        quoteDataForNav,
        scope,
        scopeGstInclusive,
        quoteTotalForNav,
        scopeTotalForNav,
    } = options;

    if (!(((stage === 4 && !quoteEditorOpen) || quoteEditorOpen) && !navMessage)) {
        return null;
    }

    const scopeList = Array.isArray(scope) ? scope : [];
    const quoteScope = Array.isArray(quoteDataForNav?.scope) ? quoteDataForNav.scope : [];

    return {
        items: quoteEditorOpen
            ? (quoteScope.length > 0 ? quoteScope.length : scopeList.length)
            : scopeList.length,
        totalLabel: quoteEditorOpen
            ? 'Total inc GST'
            : (scopeGstInclusive ? 'Total inc GST' : 'Subtotal ex GST'),
        totalDisplay: fmtNavMoney(quoteEditorOpen ? quoteTotalForNav : scopeTotalForNav),
        title: quoteEditorOpen ? 'Final quote items + total' : 'Scope items + running quote total',
    };
}
